import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { AXIOS_INSTANCE } from "@/lib/api/axios";
import { getAccount, getGetAccountQueryKey } from "@/lib/api/generated/default/default";
import { queryClient } from "@/lib/tanstack-client";

export const Route = createFileRoute("/invoices")({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: InvoicesLayout,
  beforeLoad: async ({ search, context }) => {
    if (search.token) {
      try {
        const signInAttempt = await context.clerk.client.signIn.create({
          strategy: "ticket",
          ticket: search.token,
        });

        if (signInAttempt.status === "complete") {
          await context.clerk.setActive({
            session: signInAttempt.createdSessionId,
          });
          await context.auth.getToken({ skipCache: true });
        } else {
          Sentry.captureException(signInAttempt);
        }
      } catch (err) {
        Sentry.captureException(err);
      }
      throw redirect({ to: ".", search: {} });
    }
    AXIOS_INSTANCE.interceptors.request.use(async (config) => {
      const accessToken = await context.auth.getToken();
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      return config;
    });
  },

  loader: async ({ context }) => {
    if (context.auth.isSignedIn == false) {
      throw redirect({ to: "/" });
    }
    const account = await queryClient.fetchQuery({
      queryFn: getAccount,
      queryKey: getGetAccountQueryKey(),
    });
    if (!account) {
      // You might be logged in to Trove but not Treasure, you need to grant us an account.
      context.auth.signOut();
    }
  },
});

function InvoicesLayout() {
  return <Outlet />;
}
